// import React from "react";
// import { useAppSelector } from "../../../redux/ReduxType";
// import { MdAdd, MdCreate, MdImage, MdVideocam } from "react-icons/md";
// import ProfileIMG from "../../../assets/others/avatar.jpeg";
// import { getStatusComponent, statusList } from "./data";
// import Modal from "../modal/modal";
// import TextStatus from "./Text.status";
// import ImageStatus from "./Image.status";
// import VideoStatus from "./Video.status";

// const Status = () => {
//   const isDark = useAppSelector((state) => state.theme.isDark);
//   const auth = useAppSelector((state) => state.user);
//   const [statusModal, setStatusModal] = React.useState(false);
//   const [status, setStatus] = React.useState<string>("");

//   const handleStatusClick = (type: string) => {
//     setStatusModal(true);
//     setStatus(type);
//   };

//   const handleViewMyStatus = () => {
//     if (auth.status?.length === 0) return;
//     // setStatusModal(true);
//   };

//   return (
//     <div className="sm:w-[120px] w-[80px] sm:h-[160px] h-[80px] relative carousel-item pl-10">
//       <img
//         className={`w-full ${
//           auth.status?.length ? "border-4 border-darkBg" : ""
//         } h-full object-cover sm:rounded-lg rounded-full cursor-pointer`}
//         src={auth?.avatar || ProfileIMG}
//         onClick={handleViewMyStatus}
//         alt=""
//       />
//       <div
//         className={`dropdown dropdown-end ${
//           isDark ? "text-deepBg" : "bg-lightBg"
//         }`}
//       >
//         <div
//           tabIndex={0}
//           role="button"
//           className={`p-[4px] absolute sm:-left-32 -left-10 bottom-0 cursor-pointer w-8 h-8 rounded-full flex items-center justify-center ${
//             isDark ? "bg-deepBg text-lightText" : "bg-lightBg text-darkBg"
//           }`}
//         >
//           <MdAdd />
//         </div>
//         <ul
//           tabIndex={0}
//           className="dropdown-content menu bg-base-100 rounded-box z-[100] w-32 p-2 shadow"
//         >
//           {statusList.map((status) => {
//             return (
//               <li key={status.id}>
//                 <button
//                   onClick={() => {
//                     handleStatusClick(status.name);
//                   }}
//                 >
//                   {status.name}
//                 </button>
//               </li>
//             );
//           })}
//         </ul>
//       </div>
//       <Modal
//         showModal={statusModal}
//         setShowModal={() => {
//           setStatusModal(false);
//         }}
//       >
//         {getStatusComponent(status)}
//       </Modal>
//     </div>
//   );
// };

// export default Status;

// ------ version 2 -------
import React, { useState } from "react";
import { useAppSelector } from "../../../redux/ReduxType";
import { MdAdd } from "react-icons/md";
import ProfileIMG from "../../../assets/others/avatar.jpeg";
import { statusList } from "./data";
import Modal from "../modal/modal";
import ViewStatus from "./View.status";
import TextStatus from "./Text.status";
import ImageStatus from "./Image.status";
import VideoStatus from "./Video.status";

const Status = () => {
  const isDark = useAppSelector((state) => state.theme.isDark);
  const auth = useAppSelector((state) => state.user);
  const [statusModal, setStatusModal] = useState(false);
  const [status, setStatus] = useState<string>("");
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [viewStatusModal, setViewStatusModal] = useState(false);

  const handleStatusClick = (type: string) => {
    setStatusModal(true);
    setStatus(type);
    setDropdownOpen(false); // Close the dropdown
  };

  const handleViewMyStatus = () => {
    const userStatus = auth.status;
    if (userStatus?.length === 0) return;
    setViewStatusModal(true);
    // setStatusModal(true);
  };

  const handleCloseViewStatus = () => {
    setStatusModal(false);
  };

  const getStatusComponent = (statusName: string) => {
    switch (statusName) {
      case "text":
        return <TextStatus close={handleCloseViewStatus} />;
      case "image":
        return <ImageStatus close={handleCloseViewStatus} />;
      case "video":
        return <VideoStatus close={handleCloseViewStatus} />;
      default:
        return <TextStatus close={handleCloseViewStatus} />;
    }
  };

  return (
    <div className="sm:w-[120px] w-[80px] sm:h-[160px] h-[80px] relative z-20 carousel-item pl-10">
      <img
        className={`w-full ${
          auth.status?.length ? "border-4 border-darkBg" : ""
        } h-full object-cover sm:rounded-lg rounded-full cursor-pointer`}
        src={auth?.avatar || ProfileIMG}
        onClick={handleViewMyStatus}
        alt=""
      />
      <div className={`relative ${isDark ? "text-deepBg" : "bg-lightBg"}`}>
        <div
          tabIndex={0}
          role="button"
          className={`p-[4px] absolute sm:-left-32 -left-10 bottom-0 cursor-pointer w-8 h-8 rounded-full flex items-center justify-center ${
            isDark ? "bg-deepBg text-lightText" : "bg-lightBg text-darkBg"
          }`}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          <MdAdd />
        </div>
        {dropdownOpen && (
          <ul className="absolute bg-base-100 rounded-box z-[100] w-32 p-2 shadow">
            {statusList.map((status) => (
              <li className="p-2 hover:bg-gray-200 rounded-md" key={status.id}>
                <button onClick={() => handleStatusClick(status.name)}>
                  {status.name}
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>
      <Modal showModal={statusModal} setShowModal={handleCloseViewStatus}>
        {getStatusComponent(status)}
      </Modal>

      <Modal
        showModal={viewStatusModal}
        setShowModal={() => setViewStatusModal(false)}
      >
        <ViewStatus
          userStatus={auth?.status as any}
          close={handleCloseViewStatus}
        />
      </Modal>
    </div>
  );
};

export default Status;
